import type { Config } from "storefront/Config";
import type { Filters } from "storefront/Filters";
import type { FittingRoom } from "storefront/FittingRoom";
import type { SellForm } from "storefront/SellForm";
import type { InternalTools } from "storefront/InternalTools";
import { empty as emptyCapsules } from "storefront/Capsules";
import type { Capsules } from "storefront/Capsules";
import articles from "./articles";
import type { Articles } from "../types/State/Articles";
import config from "./config";
import conversations from "./conversations";
import type { Conversations } from "./conversations";
import filters from "./filters";
import fittingRoom from "./fittingRoom";
import internalTools from "./internalTools";
import sellForm from "./sellForm";
import session from "./session";
import type { Session } from "./session";

export type State = {
  articles: Articles;
  capsules: Capsules;
  config: Config;
  conversations: Conversations;
  filters: Filters;
  fittingRoom: FittingRoom;
  internalTools: InternalTools;
  sellForm: SellForm;
  session: Session;
};

const createInitialState = (): State => ({
  articles: articles(window),
  capsules: emptyCapsules,
  config: config(window),
  conversations: conversations(window),
  filters: filters(window),
  fittingRoom: fittingRoom(window),
  internalTools: internalTools(window),
  sellForm: sellForm(window),
  session: session(),
});

export default createInitialState;
